import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { useParams } from 'react-router-dom';
import { User } from '../../models/user';

export const useUser = () => {
  const { patient: userId } = useParams();

  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUser = async (): Promise<User> => {
    return await api({
      route: `/private/coach/users/${userId}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId ?? '',
      },
    });
  };

  const {
    data: user,
    isLoading,
    isError,
  } = useQuery<User, Error>({
    queryKey: ['user-data', userToken, userId],
    queryFn: fetchUser,
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    user,
    isLoading,
    isError,
  };
};

export default useUser;
